import React, {Component} from 'react'
import {Route} from 'react-router-dom'
import {TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ProjectListTree from '../Projects/ProjectListTree'
import JobsMain from '../JobsNotifications/JobsMain'
import {getUserPermissions} from '../../utils/userPermissions'

class Aside extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {activeTab: '1'}
  }

  static propTypes = {
    asideIsOpen: PropTypes.bool.isRequired,
    notifyCount: PropTypes.number.isRequired
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render() {
    return (
      <aside className="aside-menu">
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({active: this.state.activeTab === '1'})}
              onClick={() => {
                this.toggle('1')
              }}>
              <i className="icon-speech"/> {this.props.notifyCount !==0 && this.props.notifyCount}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({active: this.state.activeTab === '2'})}
              onClick={() => {
                this.toggle('2')
              }}>
              <i className="icon-list"/>
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1" className="p-3">
            <Route path="/:path" render={() => <JobsMain shouldRender={this.props.asideIsOpen && this.state.activeTab === '1'}/>}/>
          </TabPane>
          <TabPane tabId="2">
            {this.state.activeTab === '2' && getUserPermissions('wl_welds.projects.index') && <Route path="/:path" component={ProjectListTree}/>}
          </TabPane>
        </TabContent>
      </aside>
    )
  }
}

export default Aside



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js